<template>
    <div :style="inputStyles" class="boolean">
        <span 
            class="options tw-inline-flex tw-items-stretch"
            :style="{
                borderColor: inputStyles.color
            }"
        >
            <span class="yes tw-text-center tw-inline-block"
                :class="{ 'selected': selected == yesValue }"
                :style="{
                    ...inputStyles,
                    borderColor: inputStyles.color,
                    backgroundColor: (selected == yesValue) ? convertHexToRGBA(inputStyles.color, 15) : convertHexToRGBA(inputStyles.color, 5),
                }"
                @click="onAnswerInput(yesValue)">{{ yesValue }}</span>
            <span class="no tw-text-center tw-inline-block"
                :class="{ 'selected': selected == noValue }"
                :style="{
                    ...inputStyles,
                    backgroundColor: (selected == noValue) ? convertHexToRGBA(inputStyles.color, 15) : convertHexToRGBA(inputStyles.color, 5),
                }"
                @click="onAnswerInput(noValue)">{{ noValue }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'QuestionBoolean',
    props: {
        value: {
            type: String,
            default: undefined
        },
        inputStyles: {
            type: Object,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            selected: null
        }
    },
    watch: {
        value: {
            handler(value) {
                if (value) this.selected = value;
                this.answer(value);
            },
            immediate: true
        },
    },
    computed: {
        yesValue() {
            return this.config.yes_value ?? 'Yes'
        },
        noValue() {
            return this.config.no_value ?? 'No'
        },
    },
    methods: {
        onAnswerInput(value) {
            this.selected = value;
            this.answer(value);
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: true,
            });
        }
    }
}
</script>
